import { render } from "./labels.vue?vue&type=template&id=081b8e33&scoped=true"
import script from "./labels.vue?vue&type=script&lang=js"
export * from "./labels.vue?vue&type=script&lang=js"

import "./labels.vue?vue&type=style&index=0&id=081b8e33&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081b8e33"]])

export default __exports__